<template>
  <a-spin size="large" :spinning="loading" tip="正在加载数据中，请等待">
    <div class="order-remark-template" v-if="GroupId">
      <div class="item" style="margin-left: 0; margin-bottom: 1.3em">
        <span>当前店铺：</span>
        <a-select v-model:value="relationId" style="width: 300px; font-size: 15px" @change="getRemarkTemplate">
          <a-select-option v-for="item in mallList" :key="item.Id" :value="item.Id">
            {{ item?.auth?.ShopName }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="order-remark-template">
      <h3>支付宝订单备注设置</h3>
      <div v-if="false" class="top-tip">
        <a-tag color="red">如设置备注的位置含有商家备注 (支付宝后台可见)，会容易出无货源，请谨慎使用 !</a-tag>
      </div>
      <div class="item">
        <span>备注内容：</span>
        <a-checkbox-group v-model:value="value">
          <a-checkbox v-for="item in optionList" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <div class="item">
        <span>备注旗帜：</span>
        <a-radio-group v-model:value="flagValue">
          <a-radio :value="item.id" v-for="item in flagList" :key="item.id">
            <FlagFilled :style="{ color: item.color }" />
          </a-radio>
        </a-radio-group>
      </div>
      <div class="item">
        <span>备注位置：</span>
        <a-radio-group v-model:value="remarkType">
          <a-radio :value="item.value" v-for="item in positionList" :key="item.value">
            {{ item.label }}
          </a-radio>
        </a-radio-group>
      </div>
      <div v-if="false" class="item">
        <span>如果订单带有赠品时，订单发货后是否自动把赠品单一起发货</span>
        <a-switch
          class="send-gift-switch"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="是"
          un-checked-children="否"
          v-model:checked="sendGiftTogether"
        />
      </div>
      <h3>采购订单设置</h3>
      <div class="item">
        <span>备注内容：</span>
        <a-radio-group v-model:value="purchasedOrderRemarkType">
          <a-radio :value="item.value" v-for="item in purchasedOrderRemarkTypeList" :key="item.value">
            {{ item.label }}
          </a-radio>
        </a-radio-group>
      </div>
      <div class="item">
        <a-button type="primary" class="save-btn" @click="saveMallRemarkTemplate">保存</a-button>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { FlagFilled } from "@ant-design/icons-vue";
import { mapGetters } from "vuex";
import handler from "./handler";
import { FlagModels } from "@/utils/constant/order_flag";
export default {
  components: { FlagFilled },
  data() {
    return {
      loading: true,
      value: [],
      flagValue: 0,
      remarkType: 1,
      sendGiftTogether: 0,
      purchasedOrderRemarkType: 0,
      flagList: [],
      onlyMall: false, //当前是否单店铺
      mallList: [],
      relationId: null,
      mallName: "",
      optionList: handler.optionList,
      positionList: [
        { label: "只保存到本地备注", value: 1 },
        { label: "保存到本地备注和商家备注", value: 0 },
      ],
      purchasedOrderRemarkTypeList: [
        { label: "使用买家的备注", value: 0 },
        { label: "使用商家的备注", value: 1 },
        { label: "不使用备注", value: 5 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      checkMall: "mall_group/checkMall",
      GroupId: "mall_group/GroupId",
    }),
  },
  methods: {
    setMallName() {
      this.mallName = this.mallList.find((item) => item.Id === this.relationId)?.auth?.ShopName || "";
    },
    async getMallList() {
      if (!this.GroupId) {
        console.log("xx");
        this.onlyMall = true;
        return;
      }
      var { mallList, success, msg } = await handler.GetMallList(this.GroupId);
      this.mallList = mallList;
      if (!success) this.$message.warn(msg);
      // 默认选中第一个
      //   if (mallList.length) this.relationId = mallList[0].Id;
      if (this.checkMall) {
        this.relationId = this.checkMall.Id;
      } else if (mallList.length) {
        this.relationId = mallList[0].Id;
      }
      this.getRemarkTemplate();
    },
    getRemarkTemplate() {
      this.setMallName();
      handler.GetMallRemarkTemplate(this);
    },
    saveMallRemarkTemplate() {
      handler.SaveMallRemarkTemplate(this);
    },
    async init() {
      // 1. 获取店铺列表
      this.getMallList();
      // 2. 获取旗帜的配置
      this.flagList = FlagModels();
      this.loading = false;
    },
  },
  watch: {
    GroupId(newVal, oldVal) {
      if (newVal != oldVal) this.getMallList();
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
